import React from "react";
import PropTypes from "prop-types";
import {Container, Sidebar, Content} from "./styles";

/**
 * Layout de 2 colunas (cards) reutilizado pelas abas do Group Manager que têm
 * menu lateral + área de conteúdo: Group settings, Members e Operator access.
 * É só a ESTRUTURA — o conteúdo real de cada aba é peça futura.
 */
const TabScreen = ({sidebar, children}) => (
    <Container>
        <Sidebar>{sidebar}</Sidebar>
        <Content>{children}</Content>
    </Container>
);

TabScreen.propTypes = {
    sidebar: PropTypes.node.isRequired,
    children: PropTypes.node,
};

export default TabScreen;
